import { render, staticRenderFns } from "./AdminControls.vue?vue&type=template&id=09acf47c&scoped=true&"
import script from "./AdminControls.vue?vue&type=script&lang=ts&"
export * from "./AdminControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09acf47c",
  null
  
)

export default component.exports